import React from 'react';
import vanillaFetchAPI from '../utils/fetchAPI';
import vanillaFetchAll from '../utils/fetchAll';
import { FetchCallbacksContext } from '../internal-components/FetchCallbacks';

export default function useFetchWithCallbacks() {
  const fetchCallbacks = React.useContext(FetchCallbacksContext) || {};
  const defaultCallbacks = fetchCallbacks.defaultCallbacks || {};
  
  const fetchAPI = React.useCallback(
    (endpoint, options) =>
      vanillaFetchAPI(endpoint, {
        ...defaultCallbacks,
        ...options
      }),
    [defaultCallbacks]
  );

  return fetchAPI;
}

export const useFetchAllWithCallbacks = () => {
  const fetchCallbacks = React.useContext(FetchCallbacksContext) || {};
  const defaultCallbacks = fetchCallbacks.defaultCallbacks || {};
  
  const fetchAll = React.useCallback(
    (endpoint, options) =>
      vanillaFetchAll(endpoint, {
        ...defaultCallbacks,
        ...options
      }),
    [defaultCallbacks]
  );

  return fetchAll;
};
